import {addEventByClassName, getElementById} from "./helpers";

export const Content = {
    init: function () {
        addEventByClassName('click', 'menu-btn', this.menu.toggle)
    },
    menu: {
        toggle: function (event) {
            getElementById('content-menu-button').classList.toggle('active')
            getElementById('content-menu').classList.toggle('active')
        }
    }
}
